import * as React from 'react';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { EditingStyle } from '../../types';
import { EditingStylesListItem } from './EditingStylesListItem';
import { Translate } from '../../../../shared/LanguageService';

type EditingStylesListProps = {
    editingStyles: EditingStyle[];
    onEdit: (editingStyle: EditingStyle) => void;
};

export function EditingStylesList({ editingStyles, onEdit }: EditingStylesListProps) {
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{Translate('editing-styles/list/header/name')}</TableCell>
                    <TableCell>{Translate('editing-styles/list/header/description')}</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {editingStyles.map((editingStyle) => (
                    <EditingStylesListItem
                        key={editingStyle.id}
                        id={editingStyle.id}
                        name={editingStyle.name}
                        description={editingStyle.description}
                        isActive={editingStyle.isActive}
                        onEdit={onEdit}
                    />
                ))}
            </TableBody>
        </Table>
    );
}
